<template>
  <ModalComponent
    class="ConfirmRemoveCoveragesModal"
    v-model:value="open"
  >
    <i
      class="icon-advertencia"
      aria-hidden="true"
    ></i>
    <h2 class="gl_form-title small">
      {{ t('copy_better-assurance-modal_title') }}
    </h2>

    <p>{{ t('copy_better-assurance-modal_description') }}</p>

    <div class="actions">
      <BaseButton
        type="primary"
        @click="emit('repricing')"
      >
        {{ t('copy_better-assurance-modal_button-yes') }}
      </BaseButton>

      <BaseButton
        type="transparent"
        @click="emit('close')"
      >
        {{ t('copy_better-assurance-modal_button-no') }}
      </BaseButton>
    </div>
  </ModalComponent>
</template>

<script setup lang="ts">
  import BaseButton from '@/modules/core/components/ui/BaseButton.vue'
  import ModalComponent from '@/modules/core/components/utils/ModalComponent.vue'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()

  const emit = defineEmits(['close', 'repricing'])
  const open = defineModel('open', { type: Boolean, default: false })
</script>

<style lang="scss" scoped>
  .ConfirmRemoveCoveragesModal {
    i {
      font-size: $font-size-80;
      margin-bottom: $spacing-xl;
      text-align: center;
      display: block;
    }

    h2 {
      font-weight: $font-weight-700;
      text-wrap: balance;
      max-width: $size-600;
      text-align: center;
      margin: 0 auto;
    }

    p {
      margin: $spacing-44 auto $spacing-74;
      text-align: center;
      font-size: $font-size-l;
      color: $color-primary-dark;
      line-height: $line-height-130p;
    }
  }
</style>
